import { createModel } from "@rematch/core";
import { PaginationFactory } from "../factory";
import { InsightsDashboardTypes } from "../types/insights-dashboard.types";
import { RootModel } from ".";

export interface InsightStoreProps {
    summaryData: InsightsDashboardTypes.WidgetResponse,
    pagination: PaginationFactory<InsightsDashboardTypes.Model>,
    viewDataTable: InsightsDashboardTypes.ViewDataTableResponse[],
    loading: {
        getSummaryData: boolean,
        getTableData: boolean,
        getViewDataTable: boolean,
    }
}

export const insightInitialState = {
    summaryData: {} as InsightsDashboardTypes.WidgetResponse,
    pagination: {} as PaginationFactory<InsightsDashboardTypes.Model>,
    viewDataTable: [] as InsightsDashboardTypes.ViewDataTableResponse[],
    loading: {
        getSummaryData: false,
        getTableData: false,
        getViewDataTable: false,
    }
}

export const insight = createModel<RootModel>()({
    state: insightInitialState,
    reducers: {
        toggleLoading: (store, prop: keyof InsightStoreProps['loading'], v: boolean) => {
            store.loading[prop] = v;
        },
        setPagination: (store, pagination: PaginationFactory<InsightsDashboardTypes.Model>) => {
            store.pagination = pagination;
        },
        setSummaryData: (store, summaryData: InsightsDashboardTypes.WidgetResponse) => {
            store.summaryData = summaryData;
        },
        setViewDataTable: (store, viewDataTable: InsightsDashboardTypes.ViewDataTableResponse[]) => {
            store.viewDataTable = viewDataTable;
        },
    }
})